<textarea id="ng-sql-editor" class="ng-sql-editor"></textarea>
